export default [
  {
    name: 'landing',
    path: '/landing/:section?',
    meta: {
      requireSignin: false,
    },
    component() {
      return import('@/components/main/Landing.vue')
    },
  },
  {
    name: 'landingTest1',
    path: '/landing/test/1',
    meta: {
      layout: 'EmptyLayout',
      requireSignin: false,
    },
    component() {
      return import('@/components/main/LandingTest.vue')
    },
  },
]
